import React from 'react';
import { Link } from 'react-router-dom';
import Panel from '../../components/ui/Panel';

const DownloadsPage: React.FC = () => {
  return (
    <div>
      <h1 id="overview" className="text-3xl text-osrs-gold font-bold uppercase mb-4">Downloads</h1>
      <p className="text-osrs-yellow mb-8">
        Install the React package. The stone look ships as CSS, not as a sprite sheet. There is no Sketch, Adobe XD, or Figma kit file in this repository.
      </p>

      <section id="design-files" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Design Files</h2>
        <Panel>
          <p className="text-osrs-yellow">
            Match the bevel and the colour tokens from the foundations pages. A hosted Figma library is not part of this package. See the <Link className="text-osrs-gold" to="/resources/figma">Figma notes</Link> for the shapes to redraw.
          </p>
        </Panel>
      </section>

      <section id="code-assets" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Code Assets</h2>
        <Panel>
          <p className="text-osrs-yellow mb-4">From a project that can install Git dependencies:</p>
          <pre className="bg-osrs-black p-4 text-osrs-yellow overflow-x-auto mb-4">npm install github:t8or/osrs-design-system</pre>
          <p className="text-osrs-yellow mb-4">Then import the stylesheet and the components:</p>
          <pre className="bg-osrs-black p-4 text-osrs-yellow overflow-x-auto">{`import 'osrs-design-system/styles.css';
import { Button, Panel } from 'osrs-design-system';`}</pre>
          <p className="text-osrs-yellow mt-4">
            The npm registry name is reserved in the package metadata. Publishing it is a maintainer step and is not required for the Git install.
          </p>
        </Panel>
      </section>

      <section id="textures" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Textures</h2>
        <Panel>
          <p className="text-osrs-yellow">
            Windows, buttons, and slots are flat stone colours with a bevel. Sampled from the bank and settings interfaces, the mass is #3E3530, the light edge is #6B5840, and the shadow edge is #1C1612. The opaque chatbox is #C4B48C. Those values are in the token file. Game textures are not bundled.
          </p>
        </Panel>
      </section>
    </div>
  );
};

export default DownloadsPage;
